import { FC, Link, Outlet} from 'external/react'

import useAuth from 'context/auth-context/hook'
import IconProfile from 'components/IconProfile'

import AdminMenu from 'layout/Menus/AdminMenu'
import { withContext } from 'context/index'

const AdminLayout: FC = () => {

	const {user} = useAuth()
	
	return (
		<>
			<div className='navbar navbar-light navbar-expand justify-content-between bg-white shadow header--navbar sticky-top'>
			<span className='navbar-brand'>
				<Link to={'/admin'} className='navbar-brand fw-bold' style={{ color: '#42C3DB' }} >
					EduSystem
				</Link>
			</span>
			<div className='navbar-collapse principal-menu' style={{justifyContent: 'flex-end'}} id='navbar-collapse'>
					<ul className='nav navbar-nav ml-auto'>
						<AdminMenu />
						<IconProfile path='admin' />
					</ul>
				</div>
			</div>
			<Outlet />
		</>
	)
}

export default withContext(AdminLayout, 'admin')
